import React, { useState, useEffect, useCallback } from "react";
// import { ACTIVE_API_BASE_URL } from "../config/apiConfig"
import apiClient from "../api/axiosClient";
import { ChevronLeft, ChevronRight, Save } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/FormProduction.css";
import SidebarGuideline from "./SidebarGuideline";
import TextField from "@mui/material/TextField";

import {downloadFile} from '../common'

// Constants for max lengths
const FIELD_MAX_LENGTH = 100;
const COMPANY_PROFILE_MAX_LENGTH = 300;
const COMMENT_MAX_LENGTH = 200;
const TEXTAREA_MAX_LENGTH = 300;
const PHONE_MAX_LENGTH = 10;

// Validation regex
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\d{10}$/;
const numberRegex = /^\d*\.?\d*$/; // Allow positive numbers (integers or decimals)
const yearRegex = /^\d{4}$/; // Allow 4-digit years

const RegistrationDigital = () => {
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(null);
  const awardTitle =
    location.state?.awardTitle || "Digital Technology Provider of the Year";
  const [userInfo, setUserInfo] = useState();
  const [formId, setFormId] = useState("Unknown");
  const [PkId, setPkId] = useState(0);
  // Form state initialization
  const [formData, setFormData] = useState({
    organisation_name: "",
    category: "Digital Technology Provider of the Year",
    mailingAddress: "",
    authorityName: "",
    authorityTitle: "",
    authorityLandline: "",
    authorityPhone: "",
    authorityEmail: "",
    applicant_name: "",
    applicant_phone: "",
    applicant_email: "",
    contact_name: "",
    contact_phone: "",
    contact_email: "",
    companyProfile: "",
    awardJustification: "",
    approvingAuthoritySignature: null,
    declaration: false,
    comment: "",
    total_revenue_digital_2425: "",
    total_revenue_digital_2324: "",
    total_revenue_company_2425: "",
    total_revenue_company_2324: "",
    projectA_name: "",
    projectA_areas: "",
    projectA_year: "",
    projectA_customers: "",
    projectA_revenue: "",
    projectA_intangible_value: "",
    projectB_name: "",
    projectB_areas: "",
    projectB_year: "",
    projectB_customers: "",
    projectB_revenue: "",
    projectB_intangible_value: "",
    projectC_name: "",
    projectC_areas: "",
    projectC_year: "",
    projectC_customers: "",
    projectC_revenue: "",
    projectC_intangible_value: "",
    techA_name: "",
    techA_year: "",
    techA_investment: "",
    techA_patents: "",
    techA_intangible_value: "",
    techB_name: "",
    techB_year: "",
    techB_investment: "",
    techB_patents: "",
    techB_intangible_value: "",
    techC_name: "",
    techC_year: "",
    techC_investment: "",
    techC_patents: "",
    techC_intangible_value: "",
    total_rnd_investment_2425: "",
    customers_2425: "",
    customers_2324: "",
    revenue_percent_digital_2425: "",
    attachments1: { description: "", file: null },
    attachments2: { description: "", file: null },
    attachments3: { description: "", file: null },
    attachments4: { description: "", file: null },
  });

  useEffect(() => {
    try {
      const stored = sessionStorage.getItem("user_info");
      if (stored) {
        const user = JSON.parse(stored);
        setUserInfo(JSON.parse(stored));
        setFormId(`DigitalRegistration_${user.id}`);

        setFormData((prev) => ({
          ...prev,
          userid: user.id || "",
          firstname: user.first_name || "",
          lastname: user.last_name || "",
          company_name: user.organisation_name || "",
          organisation_name: user.organisation_name || "",
          applicant_name: user.applicant_name || "",
          applicant_phone: user.applicant_phone || "",
          applicant_email: user.email || "",
        }));
      }
    } catch (err) {
      console.warn("Failed to parse user_info from localStorage:", err);
    }
  }, []);

  // This use Effect Prefill user Data using api;
  useEffect(() => {
    if (userInfo && formId) {
      prefillFormData();
    } else {
      console.warn(
        `userInfo OR formId is invalid; Kindly check the method. and data`
      );
    }
  }, [userInfo, formId]);

  const isSubmited = () => formData.form_mode === "submit";

  // Replace your existing prefillFormData() with this full implementation
  async function prefillFormData() {
    if (!userInfo || !formId) return;

    const url = `/digital/?user_id=${userInfo.id}&form_id=${formId}`;
    try {
      const res = await apiClient.get(url);

      // If no results
      if (!Array.isArray(res.data) || res.data.length < 1) {
        console.log("No prefill data found:", res.data);
        return;
      }

      // If multiple rows returned, pick the first (server should ideally return exactly one)
      const _ResData = res.data[0];
      setPkId(_ResData.id || 0);

      // Build newFields immutably
      const newFields = {
        // Basic fields (respect possible naming variations)
        organisation_name:
          _ResData.organisation_name ??
          _ResData.organisationName ??
          _ResData.company_name ??
          "",
        category: _ResData.category ?? "",
        mailingAddress:
          _ResData.mailing_address ?? _ResData.mailingAddress ?? "",
        authorityName: _ResData.authority_name ?? _ResData.authorityName ?? "",
        authorityTitle:
          _ResData.authority_title ?? _ResData.authorityTitle ?? "",
        authorityLandline:
          _ResData.authority_landline ?? _ResData.authorityLandline ?? "",
        authorityPhone:
          _ResData.authority_phone ?? _ResData.authorityPhone ?? "",
        authorityEmail:
          _ResData.authority_email ?? _ResData.authorityEmail ?? "",
        applicant_name:
          _ResData.applicant_name ??
          _ResData.applicantName ??
          _ResData.contact_name ??
          "",
        applicant_phone:
          _ResData.applicant_phone ??
          _ResData.applicantPhone ??
          _ResData.contact_phone ??
          "",
        applicant_email:
          _ResData.applicant_email ??
          _ResData.applicantEmail ??
          _ResData.contact_email ??
          "",
        contact_name: _ResData.contact_name ?? _ResData.contactName ?? "",
        contact_phone: _ResData.contact_phone ?? _ResData.contactPhone ?? "",
        contact_email: _ResData.contact_email ?? _ResData.contactEmail ?? "",
        companyProfile:
          _ResData.company_profile ?? _ResData.companyProfile ?? "",
        awardJustification:
          _ResData.award_justification ?? _ResData.awardJustification ?? "",
        comment: _ResData.comment ?? "",
        declaration:
          _ResData.declaration === true || _ResData.declaration === "true",
        form_mode: _ResData.form_mode ?? "draft",
      };

      // Numeric / Decimal / Integer fields -> convert to string (keeps inputs controlled)
      const numericKeys = [
        "total_revenue_digital_2425",
        "total_revenue_digital_2324",
        "total_revenue_company_2425",
        "total_revenue_company_2324",

        // Projects A/B/C
        "projectA_name",
        "projectA_areas",
        "projectA_year",
        "projectA_customers",
        "projectA_revenue",
        "projectA_intangible_value",

        "projectB_name",
        "projectB_areas",
        "projectB_year",
        "projectB_customers",
        "projectB_revenue",
        "projectB_intangible_value",

        "projectC_name",
        "projectC_areas",
        "projectC_year",
        "projectC_customers",
        "projectC_revenue",
        "projectC_intangible_value",

        // Tech A/B/C
        "techA_name",
        "techA_year",
        "techA_investment",
        "techA_patents",
        "techA_intangible_value",

        "techB_name",
        "techB_year",
        "techB_investment",
        "techB_patents",
        "techB_intangible_value",

        "techC_name",
        "techC_year",
        "techC_investment",
        "techC_patents",
        "techC_intangible_value",

        // other numeric/summary fields
        "total_rnd_investment_2425",
        "customers_2425",
        "customers_2324",
        "revenue_percent_digital_2425",
      ];

      numericKeys.forEach((k) => {
        // prefer empty string for null/undefined so controlled inputs remain stable
        const val = _ResData[k] ?? _ResData[k.toLowerCase()] ?? null;
        newFields[k] = val === null || val === undefined ? "" : String(val);
      });

      // Attachments 1..4: server stores as fields attachments1, attachments1_desc or attachments1_url
      [1, 2, 3, 4].forEach((n) => {
        const fileKey = `attachments${n}`;
        const descKey = `${fileKey}_desc`;
        newFields[fileKey] = {
          description: _ResData[descKey] ?? _ResData[`${fileKey}_desc`] ?? "",
          file: null, // file object is null until user picks a new File
          // server may return either attachmentsX or attachmentsX_url (depending on serializer)
          url: _ResData[fileKey] ?? _ResData[`${fileKey}_url`] ?? null,
        };
      });

      // Approving authority signature: store URL for preview; leave file null until user uploads new file
      newFields.approvingAuthoritySignature = null;
      newFields.approvingAuthoritySignatureUrl =
        _ResData.approving_authority_file ??
        _ResData.approving_authority_file_url ??
        null;


      // Safety: some serializers use slightly different keys; also map alternative names
      // (already covered above, but keep here to ensure nothing missed)
      if (
        !newFields.organisation_name &&
        (_ResData.company_name || _ResData.organisationName)
      ) {
        newFields.organisation_name =
          _ResData.company_name ?? _ResData.organisationName;
      }

      // Finally set the form state immutably
      setFormData((prev) => ({ ...prev, ...newFields }));

      console.log("Prefill applied for digital form, pkId:", _ResData.id);
    } catch (err) {
      console.error("prefillFormData error:", err);
    }
  }

  // UI State
  const [currentStep, setCurrentStep] = useState(1);
  const [copyApplicantData, setCopyApplicantData] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState("");

  // Validation helpers
  const validateEmail = (email) => emailRegex.test(email);
  const validatePhone = (phone) => phoneRegex.test(phone);
  const validateNumber = (value) => numberRegex.test(value) || value === "";
  const validateYear = (value) => yearRegex.test(value) || value === "";

  // Clear error on field
  const clearFieldError = useCallback((field) => {
    setFieldErrors((prev) => {
      if (prev[field]) {
        const { [field]: omitted, ...rest } = prev;
        return rest;
      }
      return prev;
    });
  }, []);

  // Handle changes for inputs/textareas/selects
  const handleChange = (name, value, index = null) => {
    if ([1, 2, 4].includes(currentStep)) {
      let applicableMaxLength = FIELD_MAX_LENGTH;
      if (name === "companyProfile")
        applicableMaxLength = COMPANY_PROFILE_MAX_LENGTH;
      else if (name === "comment") applicableMaxLength = COMMENT_MAX_LENGTH;

      if (typeof value === "string") {
        if (name === "companyProfile") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 300) {
            alert("Maximum 300 words allowed.");
            return;
          }
        } else if (name === "comment") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 200) {
            alert("Maximum 200 words allowed.");
            return;
          }
        } else if (value.length > applicableMaxLength) {
          alert(`Value cannot exceed ${applicableMaxLength} characters.`);
          return;
        }
      }
    }
    // Validate text fields
    if (["organisation_name", "authorityName", "contact_name"].includes(name)) {
      if (value && !/^[A-Za-z\s]*$/.test(value)) {
        setFieldErrors((prev) => ({
          ...prev,
          [name]: "Only letters and spaces are allowed.",
        }));
        return;
      }
    }

    // Phone validation
    if (["authorityPhone", "contact_phone"].includes(name)) {
      const numericValue = value.replace(/\D/g, "").slice(0, PHONE_MAX_LENGTH);
      setFormData((prev) => ({
        ...prev,
        [name]: numericValue,
      }));
      clearFieldError(name);
      return;
    }

    if (["authorityEmail", "contact_email"].includes(name)) {
      setFormData((prev) => ({
        ...prev,
        [name]: value || "",
      }));
      if (value && !validateEmail(value)) {
        setFieldErrors((prev) => ({
          ...prev,
          [name]: ` Please enter a valid ${
            name === "authorityEmail" ? "Authority" : "Contact"
          } email.`,
        }));
      } else {
        clearFieldError(name);
      }
      return;
    }

    if (
      [
        "projectA_year",
        "projectB_year",
        "projectC_year",
        "techA_year",
        "techB_year",
        "techC_year",
      ].includes(name)
    ) {
      const numericValue = value.replace(/\D/g, "").slice(0, 4); // Restrict to 4 digits
      setFormData((prev) => ({
        ...prev,
        [name]: numericValue,
      }));
      if (numericValue && !validateYear(numericValue)) {
        setFieldErrors((prev) => ({
          ...prev,
          [name]: "Please enter a valid 4-digit year.",
        }));
      } else {
        clearFieldError(name);
      }
      return;
    }

    // Numeric validation for quantitative fields
    if (
      [
        "total_revenue_digital_2425",
        "total_revenue_digital_2324",
        "total_revenue_company_2425",
        "total_revenue_company_2324",
        "projectA_revenue",
        "projectA_customers",
        "projectB_revenue",
        "projectB_customers",
        "projectC_revenue",
        "projectC_customers",
        "techA_investment",
        "techB_investment",
        "techC_investment",
        "total_rnd_investment_2425",
        "customers_2425",
        "customers_2324",
        "revenue_percent_digital_2425",
      ].includes(name)
    ) {
      if (value && !validateNumber(value)) {
        setFieldErrors((prev) => ({
          ...prev,
          [name]: "Please enter a valid number.",
        }));
        return;
      }
    }

    // Default handling
    setFormData((prev) => ({
      ...prev,
      [name]: typeof value === "boolean" ? value : value || "",
    }));
    clearFieldError(name);

    // Clear step-specific errors
    if (name === "organisation_name" && value && currentStep === 1)
      setError("");
    if (name === "mailingAddress" && value?.trim() && currentStep === 1)
      setError("");
    if (name === "authorityName" && value && currentStep === 2) setError("");
    if (name === "authorityTitle" && value && currentStep === 2) setError("");
    if (name === "authorityEmail" && value && currentStep === 2) setError("");
    if (name === "authorityPhone" && value && currentStep === 2) setError("");
  };

  // Handle checkbox for copying applicant data
  const handleCopyApplicantToggle = (e) => {
    const checked = e.target.checked;
    // setCopyApplicantData(checked);

    const model = {
      contact_name: "",
      contact_phone: "",
      contact_email: "",
    };

    if (checked) {
      const userInfo = JSON.parse(sessionStorage.getItem("user_info"));
      if (userInfo) {
        model.contact_name = userInfo.applicant_name;
        model.contact_phone = userInfo.applicant_phone;
        model.contact_email = userInfo.email;
      }
    }

    setFormData((prev) => ({ ...prev, ...model }));

    clearFieldError("contact_name");
    clearFieldError("contact_phone");
    clearFieldError("contact_email");
  };

  // Handle attachment changes
  const handleAttachmentChange = (key, field, value, event = null) => {
    if (field === "file" && value) {
      const file = value;
      const maxSizeInBytes = 5 * 1024 * 1024;
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

      if (!allowedTypes.includes(file.type)) {
        alert("Only JPG, PNG, and PDF files are allowed for attachments.");
        if (event) event.target.value = null;
        return;
      }
      if (file.size > maxSizeInBytes) {
        alert("File size must not exceed 5 MB for attachments.");
        if (event) event.target.value = null;
        return;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
      },
    }));
    clearFieldError(key);
  };

  // Handle approving authority signature upload
  const handleApprovingAuthorityChange = (files) => {
    const file = files[0];
    if (file) {
      const maxSizeInBytes = 5 * 1024 * 1024;
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

      if (!allowedTypes.includes(file.type)) {
        alert("Only JPG, PNG, and PDF files are allowed for the signature.");
        return;
      }
      if (file.size > maxSizeInBytes) {
        alert("File size must not exceed 5 MB for the signature.");
        return;
      }
      setFormData((prev) => ({
        ...prev,
        approvingAuthoritySignature: file,
      }));
      clearFieldError("approvingAuthoritySignature");
    }
  };

  const handlePrint = () => {
    const submissionDate = new Date("2025-08-05T15:03:00+05:30").toLocaleString(
      "en-US",
      {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
        timeZone: "Asia/Kolkata",
      }
    );

    const printContent = `
    <div style="font-family: Arial, sans-serif; padding: 20px;">
      <h1 style="text-align: center; color: #1e40af;">${awardTitle}</h1>
      <h2>Organization & Contact Details</h2>
      <p><strong>Organisation Name:</strong> ${
        formData.organisation_name || ""
      }</p>
      <p><strong>Postal Address:</strong> ${formData.mailingAddress || ""}</p>
      <h2>Approving Authority Details:</h2>
      <p><strong>Approving Authority Name:</strong> ${
        formData.authorityName || ""
      }</p>
      <p><strong>Approving Authority Designation:</strong> ${
        formData.authorityTitle || ""
      }</p>
      <p><strong>Approving Authority Landline:</strong> ${
        formData.authorityLandline || ""
      }</p>
      <p><strong>Approving Authority Phone:</strong> ${
        formData.authorityPhone || ""
      }</p>
      <p><strong>Approving Authority Email:</strong> ${
        formData.authorityEmail || ""
      }</p>

      <h2>Nodal Official Contact Details:</h2>
      <p><strong>Contact Name:</strong> ${formData.contact_name || ""}</p>
      <p><strong>Contact Phone:</strong> ${formData.contact_phone || ""}</p>
      <p><strong>Contact Email:</strong> ${formData.contact_email || ""}</p>
      <p><strong>Brief Writeup of Company's Profile:</strong> ${
        formData.companyProfile || ""
      }</p>

      <h2>Quantitative Information - Part 1</h2>
      <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 8px;">S. No.</th>
            <th style="border: 1px solid #000; padding: 8px;">Particulars</th>
            <th style="border: 1px solid #000; padding: 8px;">Remarks (Value)</th>
          </tr>
        </thead>
        <tbody>
          ${part1
            .map(
              ([num, label, key]) => `
            <tr>
              <td style="border: 1px solid #000; padding: 8px;">${num}</td>
              <td style="border: 1px solid #000; padding: 8px;">${label}</td>
              <td style="border: 1px solid #000; padding: 8px;">
                ${
                  key
                    ? key.includes("total_revenue_digital_2425")
                      ? `${formData.total_revenue_digital_2425 || ""}`:
                      key.includes("total_revenue_digital_2324")?`
                       ${
                          formData.total_revenue_digital_2324 || ""
                        }`
                      : key.includes("total_revenue_company_2425")
                      ? `${formData.total_revenue_company_2425 || ""}`:
                      key.includes("total_revenue_company_2324")?
                     ` ${
                          formData.total_revenue_company_2324 || ""
                        }`
                      : formData[key] || ""
                    : ""
                }
              </td>
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>

      <h2>Quantitative Information - Part 2</h2>
      <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 8px;">S. No.</th>
            <th style="border: 1px solid #000; padding: 8px;">Particulars</th>
            <th style="border: 1px solid #000; padding: 8px;">Remarks</th>
          </tr>
        </thead>
        <tbody>
          ${part2
            .map(
              ([num, label, key]) => `
            <tr>
              <td style="border: 1px solid #000; padding: 8px;">${num}</td>
              <td style="border: 1px solid #000; padding: 8px;">${label}</td>
              <td style="border: 1px solid #000; padding: 8px;">
                ${
                  key
                    ? key.includes("customers")
                      ? ` ${formData.customers_2425 || ""}, ${
                          formData.customers_2324 || ""
                        }`
                      : formData[key] || ""
                    : ""
                }
              </td>
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>

      <h2>Attachments</h2>
      <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 8px; width:10px">S.No</th>
            <th style="border: 1px solid #000; padding: 8px;">Description</th>
            <th style="border: 1px solid #000; padding: 8px;">File Name</th>
          </tr>
        </thead>
        <tbody>
          ${[1, 2, 3, 4]
            .map(
              (i) => `
            <tr>
              <td style="border: 1px solid #000; padding: 8px;">${i}</td>
              <td style="border: 1px solid #000; padding: 8px;">${
                formData[`attachments${i}`].description || ""
              }</td>
              <td style="border: 1px solid #000; padding: 8px;">${
                formData[`attachments${i}`].file?.name || ""
              }</td>
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>

      <h2>Comments</h2>
      <p>${formData.comment || ""}</p>

      <h2>Declaration</h2>
      <p>I declare that the information submitted is true and complete.</p>
      <br/>
      <p><strong>Approving Authority Name:</strong> ${
        formData.authorityName || ""
      }</p>
      <p><strong>Approving Authority Designation:</strong> ${
        formData.authorityTitle || ""
      }</p>
      <p><strong>Signed on:</strong> ${
        formData.signatureDate || new Date().toLocaleDateString()
      }</p>
      <p><strong>Approving Authority Signature:</strong></p>
    </div>
  `;

    // ✅ Proper HTML structure to avoid "about:blank"
    const printWindow = window.open("", "_blank", "height=600,width=800");
    printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8">
        <title>${awardTitle || "Form Submission"}</title>
      </head>
      <body>
        ${printContent}
      </body>
    </html>
  `);
    printWindow.document.close();
    printWindow.print();
  };

  // Navigation handlers
  const nextStep = () => {
    if (currentStep === 1) {
      if (!formData.mailingAddress.trim()) {
        alert("Mailing address is required.");
        return;
      }
    }
    if (currentStep === 2) {
      if (!formData.authorityName) {
        alert("Authority name is required.");
        return;
      }
      if (!formData.authorityTitle) {
        alert("Authority designation is required.");
        return;
      }
      if (!formData.authorityEmail || !validateEmail(formData.authorityEmail)) {
        alert("Please enter a valid Authority email.");
        return;
      }
      if (!formData.authorityLandline) {
        alert("Authority Landline is required.");
        return;
      }
      if (!formData.contact_name) {
        alert("Contact name is required.");
        return;
      }
      if (formData.contact_email && !validateEmail(formData.contact_email)) {
        alert("Please enter a valid Contact email.");
        return;
      }
      if (
        formData.contact_phone &&
        !validatePhone(formData.contact_phone) &&
        !copyApplicantData
      ) {
        alert("Contact phone must be exactly 10 digits.");
        return;
      }
      if (!formData.companyProfile) {
        alert("Company Profile is required.");
        return;
      }
    }
    if (currentStep === 3 && areRequiredFieldsEmpty(currentStep)) {
      if (!window.confirm("Data not entered, If you wish to continue?")) {
        return;
      }
    }
    if (currentStep === 4 && areRequiredFieldsEmpty(currentStep)) {
      if (!window.confirm("Data not entered, If you wish to continue?")) {
        return;
      }
    }

    setError("");
    if (currentStep < 5) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep((prev) => prev - 1);
  };

  // Save draft handler
  const handleSaveDraft = () => {
    localStorage.setItem(
      "registrationDigitalDraft",
      JSON.stringify({ formData })
    );
    handleSubmit(null);
    alert("Draft Saved!");
  };

  //Final Submit button

  const finalSubmit = () => {
    handleSubmit(null, "submited");
  };

  // Submit form handler
  // Replace your existing handleSubmit with this
  async function handleSubmit(event, clickType = "draft") {
    if (event) {
      event?.preventDefault();
    }
    console.log(
      "############################ Save the DAta on Server ##########################"
    );
    // 1) Make a local copy of formData so we don't rely on async state updates
    let payload = { ...formData };

    // 2) Merge user_info synchronously (don't call setFormData here)
    try {
      const raw = localStorage.getItem("user_info");
      if (raw) {
        const u = JSON.parse(raw);
        payload.userid = u.id ?? payload.userid;
        payload.firstname = u.first_name ?? payload.firstname;
        payload.lastname = u.last_name ?? payload.lastname;
        payload.company_name = u.organisation_name ?? payload.company_name;
        payload.Organisationname =
          u.organisation_name ?? payload.organisation_name;
      }
    } catch (err) {
      console.warn("Failed to load user_info:", err);
    }

    // ─── Build FormData ───────────────────────────────────
    const fd = new FormData();

    // Simple text fields
    const simpleFields = {
      organisation_name: formData.organisation_name,
      firstname: formData.firstname,
      lastname: formData.lastname,         


      category: formData.category,
      company_name: formData.companyName,
      mailing_address: formData.mailingAddress,
      authority_name: formData.authorityName,
      authority_title: formData.authorityTitle,
      authority_phone: formData.authorityPhone,
      authorityLandline: formData.authorityLandline,
      authority_email: formData.authorityEmail,
      contact_name: formData.contact_name,
      contact_phone: formData.contact_phone,
      contact_email: formData.contact_email,
      company_profile: formData.companyProfile,
      award_justification: formData.awardJustification,
      comment: formData.comment,
    };

    Object.entries(simpleFields).forEach(([key, value]) => {
      if (value != null && value !== "") {
        fd.append(key, value);
      }
    });

    fd.append("declaration", formData.declaration ? "true" : "false");

    // // Signature file
    // if (formData.approvingAuthoritySignature) {
    //   fd.append(
    //     "approving_authority_file",
    //     formData.approvingAuthoritySignature
    //   );
    // }
    fd.append("form_id", formId);
    fd.append("form_mode", clickType);
    // Add Table Pk Id;
    if (PkId > 0) fd.append("id", PkId);

    if (payload.approvingAuthoritySignature instanceof File) {
      fd.append(
        "approving_authority_file",
        payload.approvingAuthoritySignature
      );
    }
    // Quantitative fields
    const quantFields = [
      "total_revenue_digital_2425",
      "total_revenue_digital_2324",
      "total_revenue_company_2425",
      "total_revenue_company_2324",
      "projectA_name",
      "projectA_areas",
      "projectA_year",
      "projectA_customers",
      "projectA_revenue",
      "projectA_intangible_value",
      "projectB_name",
      "projectB_areas",
      "projectB_year",
      "projectB_customers",
      "projectB_revenue",
      "projectB_intangible_value",
      "projectC_name",
      "projectC_areas",
      "projectC_year",
      "projectC_customers",
      "projectC_revenue",
      "projectC_intangible_value",
      "techA_name",
      "techA_year",
      "techA_investment",
      "techA_patents",
      "techA_intangible_value",
      "techB_name",
      "techB_year",
      "techB_investment",
      "techB_patents",
      "techB_intangible_value",
      "techC_name",
      "techC_year",
      "techC_investment",
      "techC_patents",
      "techC_intangible_value",
      "total_rnd_investment_2425",
      "customers_2425",
      "customers_2324",
      "revenue_percent_digital_2425",
    ];

    quantFields.forEach((key) => {
      fd.append(key, formData[key] || "");
    });

    // Attachments
    [1, 2, 3, 4].forEach((n) => {
      const slot = formData[`attachments${n}`] || {
        description: "",
        file: null,
      };
      fd.append(`attachments${n}_desc`, slot.description || "");
      if (slot.file) {
        fd.append(`attachments${n}`, slot.file);
      }
    });
    // ─── API Request using apiClient ──────────────────────

    try {
      const response = await apiClient.post("/digital/", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // When User save the Data It will Prefill the form data and fill pkId
      prefillFormData();
    } catch (err) {
      console.error("Digital submission error:", err);
      const serverMsg =
        err?.response?.data ?? err?.message ?? JSON.stringify(err);
      alert("Submission failed: " + JSON.stringify(serverMsg));
    }
  }
   const viewFile =  async (serverPath) => {
    // "https://award-backend.fipi.org.in/media/
    const extractPath = serverPath.split('/').filter(
  (val) =>
    val !== "" && // remove empty strings
    val !== "http:" &&
    val !== "https:" &&
    val !== "media" &&
    !val.startsWith("award") &&
    !val.startsWith("localhost")
).join('/');
    
    downloadFile(extractPath)
  }

  const part1 = [
    // ["1", "Annual Revenue Declaration", ""],
    ["1", "Total Revenue Earned from Digital Technology Services"],
    ["", "in 2024-25 (INR Crore)", "total_revenue_digital_2425"],
    ["", "in 2023-24 (INR Crore)", "total_revenue_digital_2324"],
    ["2", "Total Revenue of the Company", ""],
    ["", "in 2024-25 (INR Crore)", "total_revenue_company_2425"],
    ["", "in 2023-24 (INR Crore)", "total_revenue_company_2324"],
    [
      "3",
      "Digital Technology Implemented (Mention Top  3 Technologies Only)",
      "",
    ],
    // ["3.1", "Digital Technology Project (A)", ""],
    ["3.1", "Name of Digital Technology Project - (A)", "projectA_name"],
    ["3.1.1", "Areas of Implementation ", "projectA_areas"],
    ["3.1.2", "Year of Commencement of Implementations", "projectA_year"],
    ["3.1.3", "No. of Customers as on date", "projectA_customers"],
    ["3.1.4", "Total Revenue till date (INR Crore)", "projectA_revenue"],
    [
      "3.1.5",
      "Intangible Value Provided to Customers in areas of implementation*",
      "projectA_intangible_value",
    ],
    // ["3.2", "Digital Technology Project (B)", ""],
    ["3.2", "Name of Digital Technology Project - (B)", "projectB_name"],
    ["3.2.1", "Areas of Implementation", "projectB_areas"],
    ["3.2.2", "Year of Commencement of Implementation", "projectB_year"],
    ["3.2.3", "No. of Customers as on date", "projectB_customers"],
    ["3.2.4", "Total Revenue till date (INR Crore) ", "projectB_revenue"],
    [
      "3.2.5",
      "Intangible Value Provided to Customers in areas of implementation* ",
      "projectB_intangible_value",
    ],
    // ["3.3", "Digital Technology Project (C)", ""],
    ["3.3", "Name of Digital Technology Project - (C)", "projectC_name"],
    ["3.3.1", "Areas of Implementation", "projectC_areas"],
    ["3.3.2", "Year of Commencement of Implementation", "projectC_year"],
    ["3.3.3", "No. of Customers for as on date", "projectC_customers"],
    ["3.3.4", "Total Revenue till date (INR Crore)", "projectC_revenue"],
    [
      "3.3.5",
      "Intangible Value Provided to Customers in areas of implementation* ",
      "projectC_intangible_value",
    ],
  ];

  const part2 = [
    [
      "4",
      "Upcoming / R&D on Digital Technology (Mention Top  3 Technologies Only)",
      "",
    ],
    // ["4.1", "R&D Technology A", ""],
    ["4.1", "Name of Technology - (A)", "techA_name"],
    ["4.1.1", "Year of Commencement of R&D ", "techA_year"],
    ["4.1.2", "Investment (INR Crore)", "techA_investment"],
    ["4.1.3", "Patents Obtained", "techA_patents"],
    [
      "4.1.4",
      "The intangible areas where the R&D initiative is expected to add value* ",
      "techA_intangible_value",
    ],
    // [".2", "R&D Technology B", ""],
    ["4.2", "Name of Technology - (B)", "techB_name"],
    ["4.2.1", "Year of Commencement of R&D ", "techB_year"],
    ["4.2.2", "Investment (INR Crore)", "techB_investment"],
    ["4.2.3", "Patents Obtained ", "techB_patents"],
    [
      "4.2.4",
      "The intangible areas where the R&D initiative is expected to add value*",
      "techB_intangible_value",
    ],
    // ["4.3", "R&D Technology C", ""],
    ["4.3", "Name of Technology - (C)", "techC_name"],
    ["4.3.1", "Year of Commencement of R&D ", "techC_year"],
    ["4.3.2", "Investment (INR Crore)", "techC_investment"],
    ["4.3.3", "Patents Obtained", "techC_patents"],
    [
      "4.3.4",
      "The intangible areas where the R&D initiative is expected to add value*",
      "techC_intangible_value",
    ],
    [
      "4.4",
      "Total Investment in R&D in 2024-25 (INR Crore)",
      "total_rnd_investment_2425",
    ],
    ["5", "Number of Customers ", ""],
    ["", " in 2024-25 (Nos.)", "customers_2425"],
    ["", " in 2023-24 (Nos.)", "customers_2324"],
    [
      "6",
      " % of Revenue earned through Digital Technology Services (in 2024-25) ",
      "revenue_percent_digital_2425",
    ],
  ];

  const areRequiredFieldsEmpty = (step) => {
    const stepData = step === 3 ? part1 : part2;

    for (const [, , key] of stepData) {
      const val = formData[key];
      if (!val || val === "") {
        if (key && !["someOptionalKey1", "someOptionalKey2"].includes(key)) {
          return true;
        }
      }
    }

    if (step === 4) {
      if (!formData.comment || formData.comment.trim() === "") {
        return true;
      }
    }

    return false;
  };

  const renderStepContent = () => {
    const progress = ((currentStep - 1) / 4) * 100;
    return (
      <div
        className="form-step"
        role="region"
        aria-label={`Step ${currentStep} of 5`}
      >
        <div
          className="progress-bar"
          role="progressbar"
          aria-valuenow={progress}
          aria-valuemin="0"
          aria-valuemax="100"
        >
          <div className="progress" style={{ width: `${progress}%` }}></div>
        </div>

        {currentStep === 1 && (
          <div>
            <h3 className="step-title">Step 1: Organization Details</h3>
            <div className="form-group">
              <label htmlFor="Organisationname">
                Organisation Name:
                {/* <span className="text-red">*</span> */}
              </label>
              <input
                id="organisation_name"
                type="text"
                name="organisation_name"
                value={formData.organisation_name}
                // onChange={(e) => handleChange("Organisationname", e.target.value)}
                disabled={true}
                className={`form-input ${
                  !formData.organisation_name && currentStep === 1
                    ? "has-error"
                    : ""
                }`}
                placeholder="Enter organisation name"
                maxLength={FIELD_MAX_LENGTH}
                aria-required="true"
              />
            </div>

            <div className="form-group">
              <label htmlFor="mailingAddress">
                Postal Address <span className="text-red">*</span>
              </label>
              <textarea
                id="mailingAddress"
                name="mailingAddress"
                value={formData.mailingAddress}
                onChange={(e) => handleChange("mailingAddress", e.target.value)}
                className={`form-textarea ${
                  !formData.mailingAddress && currentStep === 1
                    ? "has-error"
                    : ""
                }`}
                rows={3}
                placeholder="Enter Postal address"
                aria-required="true"
                maxLength={TEXTAREA_MAX_LENGTH}
              />
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div>
            <h3 className="step-title">
              Step 2: Approving Authority & Contact
            </h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="step-section">
                <h4>Approving Authority</h4>
                <p className="note">
                  Approving authority should be concerned Director /Board level
                  executive.{" "}
                </p>
                <div className="form-group">
                  <label htmlFor="authorityName">
                    Name <span className="text-red">*</span>
                  </label>
                  <input
                    id="authorityName"
                    type="text"
                    name="authorityName"
                    value={formData.authorityName}
                    onChange={(e) =>
                      handleChange("authorityName", e.target.value)
                    }
                    className={`form-input ${
                      !formData.authorityName && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    placeholder="Name"
                    maxLength={FIELD_MAX_LENGTH}
                    aria-required="true"
                  />
                  {fieldErrors.authorityName && (
                    <span
                      id="authorityName-error"
                      className="error-tooltip"
                      role="alert"
                    >
                      {fieldErrors.authorityName}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="authorityTitle">
                    Designation <span className="text-red">*</span>
                  </label>
                  <input
                    id="authorityTitle"
                    type="text"
                    name="authorityTitle"
                    value={formData.authorityTitle}
                    onChange={(e) =>
                      handleChange("authorityTitle", e.target.value)
                    }
                    className={`form-input ${
                      !formData.authorityTitle && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    placeholder="Designation"
                    maxLength={FIELD_MAX_LENGTH}
                    aria-required="true"
                  />
                  {fieldErrors.authorityTitle && (
                    <span
                      id="authorityTitle-error"
                      className="error-tooltip"
                      role="alert"
                    >
                      {fieldErrors.authorityTitle}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="authorityPhone">
                    Landline:{" "}
                    <span className="text-red" aria-hidden="true">
                      *
                    </span>
                  </label>
                  <input
                    id="authorityLandline"
                    type="number"
                    name="authorityLandline"
                    value={formData.authorityLandline}
                    onChange={(e) =>
                      handleChange("authorityLandline", e.target.value)
                    }
                    // onBlur={(e) => handleBlur('authorityLandline', e.target.value)}
                    className={`form-input ${
                      !formData.authorityLandline && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    placeholder="Landline number"
                    aria-required="true"
                    aria-describedby={
                      fieldErrors.authorityLandline
                        ? "authorityLandline-error"
                        : undefined
                    }
                  />
                  {!formData.authorityLandline && currentStep === 2 && (
                    <span className="error-tooltip">
                      Authority Landline Number is required
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="authorityPhone">
                    Mobile:
                    {/* <span className="text-red" aria-hidden="true">*</span> */}
                  </label>
                  <input
                    id="authorityPhone"
                    type="tel"
                    name="authorityPhone"
                    value={formData.authorityPhone}
                    onChange={(e) =>
                      handleChange("authorityPhone", e.target.value)
                    }
                    // onBlur={(e) => handleBlur('authorityPhone', e.target.value)}
                    className={`form-input`}
                    placeholder="Phone number"
                    maxLength={PHONE_MAX_LENGTH}
                    aria-required="true"
                    // aria-describedby={fieldErrors.authorityPhone ? 'authorityPhone-error' : undefined}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="authorityEmail">
                    Email Address <span className="text-red">*</span>
                  </label>
                  <input
                    id="authorityEmail"
                    type="email"
                    name="authorityEmail"
                    value={formData.authorityEmail}
                    onChange={(e) =>
                      handleChange("authorityEmail", e.target.value)
                    }
                    className={`form-input ${
                      !formData.authorityEmail && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    placeholder="E-mail address"
                    aria-required="true"
                  />
                  {fieldErrors.authorityEmail && (
                    <span
                      id="authorityEmail-error"
                      className="error-tooltip"
                      role="alert"
                    >
                      {fieldErrors.authorityEmail}
                    </span>
                  )}
                </div>
              </div>

              <div className="step-section">
                <h4>
                  Contacts (Nodal Officials) <span className="text-red">*</span>
                </h4>
                <div className="form-group">
                  <label>
                    <input
                      type="checkbox"
                      name="copyApplicantData"
                      // checked={copyApplicantData}
                      onChange={handleCopyApplicantToggle}
                      className="form-checkbox"
                    />{" "}
                    Same as applicant
                  </label>
                </div>

                <div className="form-group">
                  <label htmlFor="contact_name">
                    Name{" "}
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="contact_name"
                    name="contact_name"
                    type="text"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.contact_name}
                    onChange={(e) =>
                      handleChange("contact_name", e.target.value)
                    }
                    placeholder="Contact name"
                    disabled={copyApplicantData}
                    className={`form-input ${
                      !formData.contact_name && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    aria-describedby="contact_name-error"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact_phone">
                    Phone:
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="contact_phone"
                    name="contact_phone"
                    type="tel"
                    maxLength={PHONE_MAX_LENGTH}
                    value={formData.contact_phone}
                    onChange={(e) =>
                      handleChange("contact_phone", e.target.value)
                    }
                    aria-describedby="contact_phone-error"
                    disabled={copyApplicantData}
                    placeholder="10-digit phone number"
                    className={`form-input ${
                      !formData.contact_phone && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact_email">Email</label>
                  <input
                    id="contact_email"
                    name="contact_email"
                    type="email"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.contact_email}
                    onChange={(e) =>
                      handleChange("contact_email", e.target.value)
                    }
                    placeholder="Contact email"
                    disabled={copyApplicantData}
                    className={`form-input ${
                      fieldErrors.contact_email ? "has-error" : ""
                    }`}
                    aria-describedby="contact_email-error"
                  />
                </div>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="companyProfile">
                Brief Writeup of Company's Profile
              </label>
              <p className="note"> (within 300 words)</p>
              <textarea
                id="companyProfile"
                name="companyProfile"
                value={formData.companyProfile}
                onChange={(e) => handleChange("companyProfile", e.target.value)}
                className={`form-textarea ${
                  !formData.companyProfile && currentStep === 2
                    ? "has-error"
                    : ""
                }`}
                rows={6}
                // maxLength={COMPANY_PROFILE_MAX_LENGTH}
              />
              {fieldErrors.companyProfile && (
                <span
                  id="companyProfile-error"
                  className="error-tooltip"
                  role="alert"
                >
                  {fieldErrors.companyProfile}
                </span>
              )}
            </div>
          </div>
        )}

        {currentStep === 3 && (
          <div>
            <h3 className="step-title">
              Step 3: Quantitative Information Part 1
            </h3>
            <table className="quant-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Particulars</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {part1.map(([num, label, key]) => {
                  const isBold = [
                    "1",
                    "2",
                    "3",
                    "3.1",
                    "3.2",
                    "3.3",
                    "4",
                    "4.1",
                    "4.2",
                    "4.3",
                    "4.4",
                  ].includes(num.toString());

                  return (
                    <tr
                      key={key || num}
                      style={{ fontWeight: isBold ? "bold" : "normal" }}
                    >
                      <td>{num}</td>
                      <td>{label}</td>
                      <td>
                        {/* Show only text for specific rows */}
                        {num === "1" || num === "2" ? (
                          <span></span>
                        ) : num === "5" ? (
                          <span></span>
                        ) : key ? (
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            type={
                              key.includes("year") ||
                              key.includes("revenue") ||
                              key.includes("customers")
                                ? "text"
                                : "text"
                            }
                            // always "text" to prevent browser number spinners
                            value={formData[key] || ""}
                            onChange={(e) => {
                              let val = e.target.value;

                              // If this is a numeric field, allow only digits and one decimal point
                              if (
                                key.includes("year") ||
                                key.includes("revenue") ||
                                key.includes("customers")
                              ) {
                                val = val.replace(/[^0-9.]/g, "");
                                const parts = val.split(".");
                                if (parts.length > 2) {
                                  val =
                                    parts[0] + "." + parts.slice(1).join("");
                                }
                              }

                              handleChange(key, val);
                            }}
                            onKeyDown={(e) => {
                              // For numeric fields, block invalid characters
                              if (
                                key.includes("year") ||
                                key.includes("revenue") ||
                                key.includes("customers")
                              ) {
                                if (
                                  ["-", "+", "e", "E"].includes(e.key) ||
                                  e.key === "ArrowUp" ||
                                  e.key === "ArrowDown"
                                ) {
                                  e.preventDefault();
                                }
                              }
                            }}
                            onWheel={(e) => {
                              if (
                                key.includes("year") ||
                                key.includes("revenue") ||
                                key.includes("customers")
                              ) {
                                e.target.blur(); // disable mouse scroll increment
                              }
                            }}
                            className={`form-input ${
                              fieldErrors[key] ? "has-error" : ""
                            }`}
                            aria-label={`${label} input`}
                            aria-describedby={
                              fieldErrors[key] ? `${key}-error` : undefined
                            }
                            inputProps={{
                              maxLength:
                                key.includes("name") ||
                                key.includes("areas") ||
                                key.includes("intangible_value")
                                  ? FIELD_MAX_LENGTH
                                  : key.includes("year")
                                  ? 4
                                  : undefined,
                              inputMode:
                                key.includes("year") ||
                                key.includes("revenue") ||
                                key.includes("customers")
                                  ? "decimal"
                                  : undefined,
                              pattern:
                                key.includes("year") ||
                                key.includes("revenue") ||
                                key.includes("customers")
                                  ? "[0-9]*\\.?[0-9]*"
                                  : undefined,
                              min:
                                key.includes("year") ||
                                key.includes("revenue") ||
                                key.includes("customers")
                                  ? 0
                                  : undefined,
                            }}
                          />
                        ) : (
                          <span></span>
                        )}
                        {fieldErrors[key] && (
                          <span
                            id={`${key}-error`}
                            className="error-tooltip"
                            role="alert"
                          >
                            {fieldErrors[key]}
                          </span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {currentStep === 4 && (
          <div>
            <h3 className="step-title">
              Step 4: Quantitative Information Part 2
            </h3>
            <table className="quant-table">
              <thead>
                <tr>
                  <th scope="col">S. No.</th>
                  <th scope="col">Particulars</th>
                  <th scope="col">Remarks</th>
                </tr>
              </thead>
              <tbody>
                {part2.map(([num, label, key]) => {
                  const isNumericField =
                    key?.includes("year") ||
                    key?.includes("investment") ||
                    key?.includes("customers");
                  const isBold = [
                    "1",
                    "2",
                    "3",
                    "3.1",
                    "3.2",
                    "3.3",
                    "4",
                    "4.1",
                    "4.2",
                    "4.3",
                    "4.4",
                    "5",
                    "6",
                  ].includes(num.toString());

                  return (
                    <tr
                      key={key || num}
                      style={{ fontWeight: isBold ? "bold" : "normal" }}
                    >
                      <td>{num}</td>
                      <td>{label}</td>
                      {/* <td>
                {key ? (
                  isPercentField ? (
                    // Special handling for percent fields
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      <input
                        type="text"
                        name={key}
                        value={formData[key] || ""}
                        onChange={(e) => {
  let val = e.target.value.replace(/\D/g, ""); // keep only digits
  if (val.length > 3) val = val.slice(0, 3);   // max 3 digits

  // Convert to number to validate
  let num = parseInt(val || "0", 10);

  if (num > 100) {
    num = 100; // clamp at 100
  }

  const errorMsg = num > 100 ? "Value must be less than or equal to 100" : "";
  setFieldErrors((prev) => ({
    ...prev,
    [key]: errorMsg,
  }));

  handleChange(key, num.toString()); // save as string in formData
}}

                        className={`form-input ${
                          fieldErrors[key] ? "has-error" : ""
                        }`}
                        aria-describedby={
                          fieldErrors[key] ? `${key}-error` : undefined
                        }
                        style={{ paddingRight: "24px" }}
                      />
                      <span
                        style={{
                          position: "absolute",
                          right: "8px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          color: "#555",
                        }}
                      >
                        %
                      </span>
                    </div>
                  ) : (
                    // Default handling for other fields
                    <input
                      type={
                        key.includes("year") ||
                        key.includes("investment") ||
                        key.includes("customers")
                          ? "number"
                          : "text"
                      }
                      value={formData[key] || ""}
                      onChange={(e) => handleChange(key, e.target.value)} // ✅ standardized
                      className={`form-input ${
                        fieldErrors[key] ? "has-error" : ""
                      }`}
                      aria-label={`${label} input`}
                      aria-describedby={
                        fieldErrors[key] ? `${key}-error` : undefined
                      }
                      maxLength={
                        key.includes("name") ||
                        key.includes("patents") ||
                        key.includes("intangible_value")
                          ? FIELD_MAX_LENGTH
                          : key.includes("year")
                          ? 4
                          : undefined
                      }
                      step={
                        key.includes("investment") ||
                        key.includes("customers")
                          ? "0.01"
                          : undefined
                      }
                    />
                  )
                ) : (
                  <span></span>
                )}

                {fieldErrors[key] && (
                  <span
                    id={`${key}-error`}
                    className="error-tooltip"
                    role="alert"
                  >
                    {fieldErrors[key]}
                  </span>
                )}
              </td> */}
                      <td>
                        {key ? (
                          <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            type="text" // always text to prevent browser spinners
                            name={key}
                            value={formData[key] || ""}
                            onChange={(e) => {
                              let val = e.target.value;

                              // For numeric fields: allow only digits and one decimal point
                              if (isNumericField) {
                                val = val.replace(/[^0-9.]/g, "");
                                const parts = val.split(".");
                                if (parts.length > 2) {
                                  val =
                                    parts[0] + "." + parts.slice(1).join("");
                                }
                              }

                              handleChange(key, val);
                            }}
                            onKeyDown={(e) => {
                              if (isNumericField) {
                                if (
                                  ["-", "+", "e", "E"].includes(e.key) ||
                                  e.key === "ArrowUp" ||
                                  e.key === "ArrowDown"
                                ) {
                                  e.preventDefault();
                                }
                              }
                            }}
                            onWheel={(e) => {
                              if (isNumericField) e.target.blur();
                            }}
                            className={`form-input ${
                              fieldErrors[key] ? "has-error" : ""
                            }`}
                            aria-label={`${label} input`}
                            aria-describedby={
                              fieldErrors[key] ? `${key}-error` : undefined
                            }
                            inputProps={{
                              inputMode: isNumericField ? "decimal" : undefined,
                              pattern: isNumericField
                                ? "[0-9]*\\.?[0-9]*"
                                : undefined,
                              min: isNumericField ? 0 : undefined,
                              maxLength:
                                key.includes("name") ||
                                key.includes("patents") ||
                                key.includes("intangible_value")
                                  ? FIELD_MAX_LENGTH
                                  : key.includes("year")
                                  ? 4
                                  : undefined,
                              step:
                                key.includes("investment") ||
                                key.includes("customers")
                                  ? "0.01"
                                  : undefined,
                            }}
                          />
                        ) : (
                          <span></span>
                        )}

                        {fieldErrors[key] && (
                          <span
                            id={`${key}-error`}
                            className="error-tooltip"
                            role="alert"
                          >
                            {fieldErrors[key]}
                          </span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <br />
            <br />

            <div className="form-group">
              <label htmlFor="comment">Comments</label>
              <textarea
                id="comment"
                name="comment"
                value={formData.comment}
                onChange={(e) => handleChange("comment", e.target.value)} // ✅ standardized
                className={`form-textarea ${
                  fieldErrors.comment ? "has-error" : ""
                }`}
                placeholder="Comments in (200 characters) against input parameter, if any"
                rows={4}
              />
              {fieldErrors.comment && (
                <span id="comment-error" className="error-tooltip" role="alert">
                  {fieldErrors.comment}
                </span>
              )}
            </div>
          </div>
        )}

        {currentStep === 5 && (
          <div className="form-step">
            <h3 className="step-title">Step 5: Attachments & Declaration</h3>
            <div className="form-group">
              <label>List of Attachments (Optional):</label>
              <table className="quant-table">
                <thead>
                  <tr>
                    <th scope="col">S. No.</th>
                    <th scope="col">Description</th>
                    <th scope="col">
                      Upload (only jpg, png, pdf, max 5 MB each)
                    </th>
                  </tr>
                </thead>
                {/* <tbody>
                  {[1, 2, 3, 4].map((num) => {
                    const key = `attachments${num}`;
                    const attachment = formData[key];
                    return (
                      <tr key={key}>
                        <td>{num}</td>
                        <td>
                          <input
                            type="text"
                            name={`${key}.description`}
                            value={attachment.description}
                            onChange={(e) =>
                              handleAttachmentChange(
                                key,
                                "description",
                                e.target.value
                              )
                            }
                            placeholder="Enter description"
                            className={`form-input ${
                              fieldErrors[`${key}.description`]
                                ? "has-error"
                                : ""
                            }`}
                            maxLength={FIELD_MAX_LENGTH}
                          />
                        </td>
                        <td>
                          <input
                            type="file"
                            accept=".jpg,.png,.pdf"
                            onChange={(e) =>
                              handleAttachmentChange(
                                key,
                                "file",
                                e.target.files[0],
                                e
                              )
                            }
                            className="form-input mt-4"
                          />
                          {attachment.file && (
                            <p className="file-name">
                              Selected file: {attachment.file.name}
                            </p>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody> */}
                <tbody>
                  {[1, 2, 3, 4].map((num) => {
                    const key = `attachments${num}`;
                    const attachment = formData[key] || { description: "", file: null };
                    return (
                      <tr key={key}>
                        <td>{num}</td>
                        <td>
                          <input type="text" name={`${key}.description`} value={attachment.description} onChange={(e) => handleAttachmentChange(key, "description", e.target.value)} placeholder="Enter description" maxLength={FIELD_MAX_LENGTH} className="form-input" />
                        </td>
                        <td>
                          <input type="file" accept=".jpg,.png,.pdf" onChange={(e) => handleAttachmentChange(key, "file", e.target.files[0], e)} className="form-input mt-4" />
                          {attachment.file && <p className="file-name">Selected file: {attachment.file.name}</p>}
                          {attachment.url && !attachment.file && (
  <p className="file-name">
    Uploaded file:{" "}
    <button
      type="button"
      onClick={() => viewFile(attachment.url)}
      style={{ background: "none", border: "none", padding: 0, color: "#06c", cursor: "pointer", textDecoration: "underline" }}
    >
      View
    </button>
  </p>
)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="form-group">
              <label>
                Print the completed application form and upload it with the
                signature of the approving authority. Without signature of the
                approving authority, application will not be considered valid.{" "}
                <span className="text-red">*</span>
              </label>
              <div className="form-navigation">
                <button
                  type="button"
                  onClick={handlePrint}
                  className="btn btn-outline"
                >
                  Print Preview
                </button>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="approvingAuthoritySignature">
                Upload Document with Approving Authority Signature
                (Director/Board Level)
                <span aria-hidden="true" className="text-red">
                  *
                </span>
                :
              </label>
              <input
                type="file"
                id="approvingAuthoritySignature"
                accept=".jpg,.png,.pdf"
                onChange={(e) => {
                  const files = e.target.files;
                  if (files.length > 0) {
                    const confirmed = window.confirm(
                      "Are you sure the form is approved and signed by approving authority?"
                    );
                    if (!confirmed) {
                      // If user clicks "Cancel", clear the input
                      e.target.value = "";
                      return;
                    }
                    handleApprovingAuthorityChange(files);
                  }
                }}
                className={`form-input mt-4 ${
                  fieldErrors.approvingAuthoritySignature ? "has-error" : ""
                }`}
                aria-describedby="approvingAuthoritySignature-error"
                required
              />
              {formData.approvingAuthoritySignature && (
                <p className="file-name">
                  Selected file: {formData.approvingAuthoritySignature.name}
                </p>
              )}
               {formData.approvingAuthoritySignatureUrl && !formData.approvingAuthoritySignature && (
    <p className="file-name">
      Uploaded file:{" "}
      <button
        type="button"
        onClick={() => viewFile(formData.approvingAuthoritySignatureUrl)}
        style={{ background: "none", border: "none", padding: 0, color: "#06c", cursor: "pointer", textDecoration: "underline" }}
      >
        View
      </button>
    </p>
  )}
              {fieldErrors.approvingAuthoritySignature && (
                <span
                  className="error-tooltip"
                  id="approvingAuthoritySignature-error"
                  role="alert"
                >
                  {fieldErrors.approvingAuthoritySignature}
                </span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="declaration">
                <input
                  id="declaration"
                  type="checkbox"
                  name="declaration"
                  checked={formData.declaration}
                  onChange={(e) =>
                    handleChange("declaration", e.target.checked)
                  }
                  className="form-checkbox"
                  aria-required="true"
                />{" "}
                I declare that the information submitted is true and complete.
              </label>
              {fieldErrors.declaration && (
                <span
                  id="declaration-error"
                  className="error-tooltip"
                  role="alert"
                >
                  {fieldErrors.declaration}
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    const middlePosition = window.innerHeight / 2; // middle
    window.scrollTo({ top: middlePosition + 100, behavior: "smooth" });
  }, [currentStep]);
const navigate = useNavigate();
  return (
    <div className="sidebar-guideline-container">
      <SidebarGuideline
        isOpen={true}
        sidebarItems={[{ id: "Guideline", label: "Guideline" }]}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        selectedAwardCategory={formData.category}
      />
      <div className="application-form">
        <div className="form-header">
          <h1>{awardTitle}</h1>
          <h6>Step {currentStep} of 5</h6>
        </div>
        {error && (
          <div className="error" role="alert">
            {error}
          </div>
        )}
        {isSubmitted ? (
          <div className="thank-you-message">
            <h2>Thank you for your submission!</h2>
            <p>Your Application has been successfully submitted.</p>
            <button onClick={() => navigate("/#Award%20Categories")}>
              Submit Another Application
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {renderStepContent()}
            {currentStep === 1 && (
              <div className="form-navigation-step1">
                <button
                  type="button"
                  onClick={handleSaveDraft}
                  className="btn btn-outline"
                  disabled={isSubmited()}
                >
                  <Save size={16} /> Save Draft
                </button>
                <button
                  type="button"
                  onClick={nextStep}
                  className="btn btn-primary"
                >
                  Next <ChevronRight size={16} />
                </button>
              </div>
            )}
            {currentStep > 1 && (
              <div className="form-navigation">
                <button
                  type="button"
                  onClick={prevStep}
                  className="btn btn-outline"
                >
                  <ChevronLeft size={16} /> Previous
                </button>
                <button
                  type="button"
                  onClick={handleSaveDraft}
                  className="btn btn-outline"
                  disabled={isSubmited()}
                >
                  <Save size={16} /> Save Draft
                </button>
                {currentStep < 5 && (
                  <button
                    type="button"
                    onClick={nextStep}
                    className="btn btn-primary"
                  >
                    Next <ChevronRight size={16} />
                  </button>
                )}
                {currentStep === 5 && (
                  <button
                    type="button"
                    className="btn btn-success"
                    disabled={isSubmited()}
                    onClick={(e) => {
                      if (!formData.declaration) {
                        return alert(
                          "Please accept the declaration before submitting."
                        );
                      }
                      if (!formData.approvingAuthoritySignature) {
                        return alert(
                          "Please upload the approving authority signature file."
                        );
                      }
                      if (!window.confirm("Are you sure you want to submit?")) {
                        e.preventDefault();

                      }
                      alert("Digital registration submitted successfully!");
                      setIsSubmitted(true);

                      handleSubmit(e, "submit");
                    }}
                  >
                    Submit
                  </button>
                )}
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  );
};

export default RegistrationDigital;
